import template from './riskInsuranceComplianceVerificationsIdentity.template.html';
import templateAddNewAddress from '../address/addNewAddress.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    identity: '<',
    identities: '<',
    contacts: '<',
    addresses: '<',
    isDisabled: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $mdUtil,
      $mdMedia,
      $mdDialog,
      Address,
      YesNoOption,
      riskInsuranceService,
      helperService,
      eventService,
      financesService,
      RiskInsuranceCompliance,
      dateTimeService,
      GOOGLEMAPS
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.availableStates = [];
      ctrl.availableYesNoSelectOptionsThree = [];
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.googleAutocompleteOptions = {
          componentRestrictions: GOOGLEMAPS.restrictToCountries
        };
        ctrl.availableStates = helperService.getAvailableAddressStates();
        ctrl.availableYesNoSelectOptionsThree = helperService.getAvailableYesNoSelectOptions({
          option: 3
        });
        ctrl.identity = ctrl.identity || {};
        ctrl.identities = ctrl.identities || [];
        ctrl.contacts = ctrl.contacts || [];
        ctrl.addresses = ctrl.addresses || [];
        ctrl.isDisabled = ctrl.isDisabled || false;
        ctrl.index = _.findIndex(
          ctrl.identities || [],
          (i) => i?.idContact === ctrl.identity?.idContact
        );

        dateTimeService.getSet(ctrl, ctrl.identity, 'date', 'getSetVerificationsIdentityDate');

        ctrl.getAllAddresses();
        ctrl.isReady = true;
      };

      ctrl.getAllAddresses = () => {
        ctrl.identitiesAddresses = [];
        for (let a = 0; a < ctrl.identities?.length; a += 1) {
          const blankApplicantAddress = !ctrl.identities[a]?.address?.street
            ? Address.build(ctrl.identities[a].address)
            : Address.blank();
          const allApplicantAddresses = angular.copy(ctrl.addresses);
          allApplicantAddresses.unshift(blankApplicantAddress);
          ctrl.identitiesAddresses.push(_.compact(allApplicantAddresses));
        }
      };

      ctrl.addNewVerificationsAddress = ($event, idx) => {
        $event.stopPropagation();
        $mdDialog
          .show({
            targetEvent: $event,
            locals: {
              index: idx,
              googleAutocompleteOptions: ctrl.googleAutocompleteOptions,
              availableStates: ctrl.availableStates,
              countries: ctrl.countries
            },
            template: templateAddNewAddress,
            controllerAs: '$ctrl',
            controller(index, googleAutocompleteOptions, availableStates, countries) {
              const ctr = this;
              ctr.idx = index;
              ctr.googleAutocompleteOptions = googleAutocompleteOptions;
              ctr.availableStates = availableStates;
              ctr.countries = countries;
              ctr.address = Address.blank();
              ctr.confirm = () => {
                $mdDialog.hide({ idx: ctr.idx, address: ctr.address });
              };
              ctr.cancel = () => {
                $mdDialog.cancel();
              };
            }
          })
          .then((result) => {
            if (
              result?.address &&
              result?.address?.streetNumber !== '' &&
              result?.address?.street &&
              (result?.address?.suburb || result?.address?.city) &&
              result?.address?.postCode
            ) {
              if (result.idx !== null) {
                ctrl.identities[idx].address = result.address;
              } else {
                ctrl.interviewDetailsLocation = result.address;
              }
              ctrl.addresses.push(result.address);
              ctrl.getAllAddresses();
              ctrl.complianceChanges(true);
            }
          });
      };

      ctrl.addressChanged = () => {
        ctrl.getAllAddresses();
        ctrl.complianceChanges(true);
      };

      ctrl.getAddress = (address) =>
        address?.street ? Address.getAddress(address) : 'Select one';

      ctrl.getContact = (idContact) => _.find(ctrl.contacts || [], (c) => c?.id === idContact);

      ctrl.saveRiskInsuranceVerificationsIdentity = () => {
        ctrl.onFinished({ identity: ctrl.identity });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
